import {
  MAP_CHANGE_TYPE,
  MAP_CONFIDENCE,
  MAP_EVIDENCE_TOPIC,
  MAP_TARGET_LANE,
} from "../../enums/map";
import { pageDisplayLabel } from "../pages/boundaries/page-label.parser";
import { buildChange, type ChangeInput } from "./mapChangeBuilders";
import { issueEvidence } from "./mapEvidence";
import type { MapChange } from "./mapTypes";

export function clarifyDestinationChange(
  input: ChangeInput,
  destination: string,
  brokenLinks: number,
): MapChange {
  const sourceLabel =
    input.facts.length === 1 && input.facts[0]
      ? pageDisplayLabel(input.facts[0].page, input.data.site)
      : input.group.label;
  return buildChange(input, {
    type: MAP_CHANGE_TYPE.CLARIFY_DESTINATION,
    title: `Clarify the onward destination from ${sourceLabel}`,
    summary: "A recorded onward relationship is weakened by path evidence.",
    currentState: `${input.facts.length} ${input.group.label} page${input.facts.length === 1 ? " has" : "s have"} recorded links toward ${destination}, with related path friction in the current Scan.`,
    proposedState:
      "Confirm the intended onward destination, then make that route clear, consistently labelled and appropriate to the represented page role.",
    targetRole: "Clear onward destination",
    targetLane: MAP_TARGET_LANE.DESTINATION,
    confidence:
      brokenLinks > 0 && input.issues.length > 0
        ? MAP_CONFIDENCE.STRONG
        : MAP_CONFIDENCE.SOME,
    evidence: [
      {
        kind: "structure" as const,
        topic: MAP_EVIDENCE_TOPIC.ONWARD_RELATIONSHIP,
        detail: `Current internal links connect this group to ${destination}.`,
      },
      ...(brokenLinks > 0
        ? [
            {
              kind: "structure" as const,
              topic: MAP_EVIDENCE_TOPIC.PATH_BREAK,
              detail: `${brokenLinks} recorded relationship${brokenLinks === 1 ? " is" : "s are"} marked as broken.`,
            },
          ]
        : []),
      ...issueEvidence(
        input.issues,
        new Set(input.facts.map((fact) => fact.page.id)),
      ).slice(0, 2),
    ].slice(0, 4),
    uncertainties: [
      "The intended destination and final link wording require client confirmation.",
      "This Preview does not measure whether visitors use the path.",
    ],
  });
}
